<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Foreign experience' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group row">
      <label class="col-12 col-sm-12 col-form-label">{{'Period (from / till)' | translate}} *</label>
      <div class="col-12 col-sm-6">
        <input ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" class="form-control" [(ngModel)]="entity.startDate" (click)="startdate.toggle()" #startdate="ngbDatepicker" />
        <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'startDate')">
          <p>{{'Please fill in start date' | translate}}</p>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <input ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" class="form-control" [(ngModel)]="entity.endDate" (click)="enddate.toggle()" #enddate="ngbDatepicker" />
      </div>
    </div>

    <div class="form-group">
      <label>{{'Kind of experience' | translate}} *</label>
      <input class="form-control" [(ngModel)]="entity.title" />
      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'title')">
        <p>{{'Please fill in kind of experience' | translate}}</p>
      </div>
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}} *</label>
      <textarea class="form-control" [(ngModel)]="entity.description"></textarea>
      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'description')">
        <p>{{'Please fill in description' | translate}}</p>
      </div>
    </div>

    <div class="form-group">
      <label>{{'Company information' | translate}}</label>
      <textarea class="form-control" [(ngModel)]="entity.companyInformation"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Country' | translate}} *</label>
      <select class="form-control" [(ngModel)]="entity.country">
        <option [value]="option.code" *ngFor="let option of locale.availableCountries()">
          {{option.name}}
        </option>
      </select>
      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'country')">
        <p>{{'Please select a country' | translate}}</p>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Back' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
